import { useEffect, useState } from "react";

import { DeviceInfo, deviceInfo as staticDeviceInfo } from "../utils";

interface UseDeviceInfoReturn {
  deviceInfo: DeviceInfo | undefined;
}

/** クライアントサイドでないとブラウザ情報など正確なdeviceInfoが取得できないため */
export const useDeviceInfo = (): UseDeviceInfoReturn => {
  const [deviceInfo, setDeviceInfo] = useState(staticDeviceInfo);

  useEffect(() => {
    if (typeof window !== "undefined" && !deviceInfo) {
      setDeviceInfo(staticDeviceInfo);
    }
  }, [deviceInfo, setDeviceInfo]);

  return {
    deviceInfo,
  };
};
